import {
  GET_SEQUENCE_CONTACTS_FAIL,
  GET_SEQUENCE_CONTACTS_PENDING,
  GET_SEQUENCE_CONTACTS_SUCCESS,
  UPDATE_SEQUENCE_CONTACT_PENDING,
  UPDATE_SEQUENCE_CONTACT_FAIL,
  UPDATE_SEQUENCE_CONTACT_SUCCESS,
  UPDATE_BULK_SEQUENCE_CONTACT_PENDING,
  UPDATE_BULK_SEQUENCE_CONTACT_FAIL,
  UPDATE_BULK_SEQUENCE_CONTACT_SUCCESS,
  GET_SEQUENCE_PENDING_CONTACTS_FAIL,
  GET_SEQUENCE_PENDING_CONTACTS_PENDING,
  GET_SEQUENCE_PENDING_CONTACTS_SUCCESS,
  CREATE_SEQUENCE_CONTACTS,
  MARK_AS_FINISHED_SEQUENCE_CONTACT,
  UNMARK_AS_FINISHED_SEQUENCE_CONTACT,
  MARK_BULK_AS_FINISHED_SEQUENCE_CONTACT,
  UNMARK_BULK_AS_FINISHED_SEQUENCE_CONTACT,
} from '../actions/sequenceContactActions';
import { SET_IS_CONTACT_CUSTOMIZED } from '../actions/contactActions';


const initialState = {
  sequenceContact: {
    loading: true,
    loaded: false,
    id: null,
    contact: null,
    sequence: null,
    status_replied_date: null,
    status_interested_date: null,
    status_sponsorship_date: null,
    status_unsubscribed_date: null,
    status_not_interested_date: null,
    status_not_now_date: null,
    active: null,
    email_validation_status: null,
  },
  sequenceContacts: {
    loading: false,
    loaded: true,
    count: null,
    next: null,
    previous: null,
    results: [],
  },
};


export const sequenceContactReducer = (state = initialState.sequenceContact, action) => {
  switch (action.type) {
    case UPDATE_SEQUENCE_CONTACT_PENDING:
      return {
        ...state,
        loading: true,
        loaded: false,
        ...action.payload,
      };
    case UPDATE_SEQUENCE_CONTACT_SUCCESS:
      return {
        loading: false,
        loaded: true,
        ...action.payload,
      };
    case UPDATE_SEQUENCE_CONTACT_FAIL:
      return {
        loading: false,
        loaded: true,
        ...action.payload,
      };
    default:
      return state;
  }
};


export const sequenceContactsReducer = (state = initialState.sequenceContacts, action) => {
  switch (action.type) {
    case MARK_AS_FINISHED_SEQUENCE_CONTACT.pending:
      return {
        ...state,
        loading: true,
        loaded: false,
        ...action.payload,
      };
    case MARK_AS_FINISHED_SEQUENCE_CONTACT.error:
      return {
        ...state,
        loading: false,
        loaded: true,
        ...action.payload,
      };
    case MARK_AS_FINISHED_SEQUENCE_CONTACT.success:
      return {
        ...state,
        loading: false,
        loaded: true,
        ...action.payload.data,
      };
    case UNMARK_BULK_AS_FINISHED_SEQUENCE_CONTACT.pending:
      return {
        ...state,
        loading: true,
        loaded: false,
        ...action.payload,
      };
    case UNMARK_BULK_AS_FINISHED_SEQUENCE_CONTACT.error:
      return {
        ...state,
        loading: false,
        loaded: true,
        ...action.payload,
      };
    case UNMARK_BULK_AS_FINISHED_SEQUENCE_CONTACT.success:
      return {
        ...state,
        loading: false,
        loaded: true,
        ...action.payload.data,
      };
    case MARK_BULK_AS_FINISHED_SEQUENCE_CONTACT.pending:
      return {
        ...state,
        loading: true,
        loaded: false,
        ...action.payload,
      };
    case MARK_BULK_AS_FINISHED_SEQUENCE_CONTACT.error:
      return {
        ...state,
        loading: false,
        loaded: true,
        ...action.payload,
      };
    case MARK_BULK_AS_FINISHED_SEQUENCE_CONTACT.success:
      return {
        ...state,
        loading: false,
        loaded: true,
        ...action.payload.data,
      };
    case UNMARK_AS_FINISHED_SEQUENCE_CONTACT.pending:
      return {
        ...state,
        loading: true,
        loaded: false,
        ...action.payload,
      };
    case UNMARK_AS_FINISHED_SEQUENCE_CONTACT.error:
      return {
        ...state,
        loading: false,
        loaded: true,
        ...action.payload,
      };
    case UNMARK_AS_FINISHED_SEQUENCE_CONTACT.success:
      return {
        ...state,
        loading: false,
        loaded: true,
        ...action.payload.data,
      };
    case GET_SEQUENCE_CONTACTS_PENDING:
      return {
        ...state,
        loading: true,
        loaded: false,
        ...action.payload,
      };
    case GET_SEQUENCE_CONTACTS_FAIL:
      return {
        ...state,
        loading: false,
        loaded: true,
        ...action.payload,
      };
    case GET_SEQUENCE_CONTACTS_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        ...action.payload,
      };
    case SET_IS_CONTACT_CUSTOMIZED:
      return {
        ...state,
        results: state.results.map((c) => {
          if (c.id === action.payload.sequenceContactId) {
            return {
              ...c,
              customized: action.payload.isCustomized,
            };
          }
          return c;
        }),
      };
    case UPDATE_BULK_SEQUENCE_CONTACT_PENDING:
      return {
        ...state,
        loading: true,
        loaded: false,
        ...action.payload,
      };
    case UPDATE_BULK_SEQUENCE_CONTACT_FAIL:
      return {
        ...state,
        loading: false,
        loaded: true,
        ...action.payload,
      };
    case UPDATE_BULK_SEQUENCE_CONTACT_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        ...action.payload,
      };
    case CREATE_SEQUENCE_CONTACTS.pending:
      return {
        ...state,
        loading: true,
        loaded: true,
      };
    case CREATE_SEQUENCE_CONTACTS.success:
      return {
        ...state,
        loading: false,
        loaded: true,
      };
    case CREATE_SEQUENCE_CONTACTS.error:
      return {
        ...state,
        loading: false,
        loaded: false,
      };

    default:
      return state;
  }
};

export const sequencePendingContactsReducer = (state = initialState.sequenceContacts, action) => {
  switch (action.type) {
    case GET_SEQUENCE_PENDING_CONTACTS_PENDING:
      return {
        ...state,
        loading: true,
        loaded: false,
        ...action.payload,
      };
    case GET_SEQUENCE_PENDING_CONTACTS_FAIL:
      return {
        ...state,
        loading: false,
        loaded: true,
        ...action.payload,
      };
    case GET_SEQUENCE_PENDING_CONTACTS_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        ...action.payload,
      };
    default:
      return state;
  }
};
